export const DEBUG = /^true$/i.test(process.env.NEXT_PUBLIC_DEBUG ?? '');
export const IS_E2E = /^true$/i.test(process.env.NEXT_PUBLIC_E2E ?? '');

export const oneTrustToken = process.env.NEXT_PUBLIC_ONETRUST || '';
